// extracted by mini-css-extract-plugin
module.exports = {"form":"SignUp-module--form--EBslT","input":"SignUp-module--input--HiiEd","label":"SignUp-module--label--1kQXf","submit":"SignUp-module--submit--7piXH"};